import {envIsDev} from '../../../../config';
import afterFrame from '../../../../util/afterFrame';
import {reportTimedEvent} from '../../../../util/profiler';

const DEV_MODE = envIsDev && false;

export const logDragVital = (
  name: 'drag_start' | 'drag_end',
  context: {
    action?: string;
    alwaysLog: boolean;
    activeDragType: 'section' | 'panel';
  }
) => {
  const startTime = performance.now();
  let actualRafTimestamp: number;

  if (DEV_MODE) {
    performance.mark(`${name}-event`);
  }

  // requestAnimationFrame fires at the START of the next frame (before layout/paint)
  requestAnimationFrame(rafTimestamp => {
    if (DEV_MODE) {
      performance.mark(`${name}-frame-start`);
    }

    // rafTimestamp is the scheduled frame time (from browser)
    // But this might not be when this code actually runs, due to JS thread being blocked
    actualRafTimestamp = performance.now(); // Actual time this callback executes

    const durationRAFDelay = actualRafTimestamp - rafTimestamp;

    // afterframe fires AFTER paint completes
    afterFrame(afterPaintTimestamp => {
      if (DEV_MODE) {
        performance.mark(`${name}-frame-end`);
      }

      const durationWaitForNextFrame = actualRafTimestamp - startTime;
      const durationOfFrame = afterPaintTimestamp - actualRafTimestamp;
      const totalDuration = afterPaintTimestamp - startTime;

      if (DEV_MODE) {
        performance.measure(
          `${name}-total`,
          `${name}-event`,
          `${name}-frame-end`
        );

        console.log(`[${name}] Timing Breakdown:`, {
          expectedFrameTime: '16.67ms (60fps)',
          ...context,
          durationTotal: totalDuration,
          durationWaitForNextFrame,
          durationOfFrame,
          durationRAFDelay,
        });
      }

      reportTimedEvent({
        elapsedMs: totalDuration,
        absoluteStartTimeMs: startTime,
        name,
        context: {
          ...context,
          logToRum: true,
          durationWaitForNextFrame, // Time waiting for next frame to start
          durationOfFrame, // Time from frame start to paint complete,
          durationRAFDelay,
        },
      });
    });
  });
};
